import { Directive, HostListener } from '@angular/core'

@Directive({
  selector: '[appNumericOnly]',
  standalone: false,
})
export class NumericOnlyDirective {
  // Navigation and editing keys that should always be allowed
  private readonly allowedKeys = new Set([
    'Backspace',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Delete',
    'PageUp',
    'PageDown',
  ])

  // Control key combinations (case-insensitive)
  private readonly ctrlKeys = new Set(['a', 'c', 'v', 'x', 'z'])

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const { key, ctrlKey, metaKey } = event

    // Allow navigation and control keys
    if (this.allowedKeys.has(key)) {
      return
    }

    // Allow Ctrl/Cmd shortcuts (case-insensitive)
    if ((ctrlKey || metaKey) && this.ctrlKeys.has(key.toLowerCase())) {
      return
    }

    // Allow F1-F12 function keys
    if (this.isFunctionKey(key)) {
      return
    }

    // Allow numeric keys (0-9) - works for both main keyboard and numpad
    if (this.isNumericKey(key)) {
      return
    }

    // Block all other keys
    event.preventDefault()
  }

  /**
   * Check if the key is a function key (F1-F12)
   */
  private isFunctionKey(key: string): boolean {
    if (!key.startsWith('F')) return false

    const fKeyNumber = parseInt(key.substring(1), 10)
    return !isNaN(fKeyNumber) && fKeyNumber >= 1 && fKeyNumber <= 12
  }

  /**
   * Check if the key is a numeric key (0-9)
   */
  private isNumericKey(key: string): boolean {
    return /^[0-9]$/.test(key)
  }
}
